/* eslint-disable react/jsx-no-target-blank */
//import logo from "../../../assets/images/Rocky/RockyNavidad.webp";
import logo from "../../../assets/images/Rocky/LOGOROCKY.png";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import User from "../../../models/user";
import { jwtDecode } from "jwt-decode";
export const RockyHeader = () => {
  const [arrayUsers, setArrayUsers] = useState<User>();
  const [loading, setLoading] = useState(false);
  const myNavigate = useNavigate();

  const handleTokenError = () => {
    myNavigate("/"); // Redirigir a la página de inicio de sesión
  };

  const getProfessionals = async () => {
    try {
      const token: any = localStorage.getItem("access");
      if (!token) {
        handleTokenError();
        return;
      }
      const decoded: any = jwtDecode(token);

      if (decoded) {
        setArrayUsers(decoded);
        setLoading(false);
        return;
      } else {
        console.error("El token no contiene información de usuario válida.");
        handleTokenError();
      }

    } catch (error) {
      console.error("Error fetching professionals:", error);
      setLoading(false);
      const token = localStorage.getItem("access");
      if (token === null) {
        handleTokenError();
      }
    }
  };

  useEffect(() => {
    getProfessionals();
    const tokenTimeout = setTimeout(() => {
      localStorage.removeItem("access");
      console.log("Token eliminado después de 12 hora");
      handleTokenError(); // Redirect to login
    }, 43200000); // 12 hours

    return () => clearTimeout(tokenTimeout); // clean to setTimeout next to token expiration
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return (
    <>
      <div
        className="container d-flex justify-content-center align-items-center"
        style={{
          minHeight: "80vh",
        }}
      >
        <div
          className="p-5 shadow-lg rounded-4 text-center"
          style={{
            width: "100%",
            maxWidth: "900px",
            background: "rgba(255, 255, 255, 0.12)",
            backdropFilter: "blur(12px)",
            WebkitBackdropFilter: "blur(12px)",
            border: "1px solid rgba(255, 255, 255, 0.3)",
            userSelect: "none",
            WebkitUserSelect: "none",
            MozUserSelect: "none",
            msUserSelect: "none",
          }}
        >
          {/* LOGO */}
          <div className="mb-4 d-flex justify-center">
            <img
              src={logo}
              alt="Rocky Logo"
              style={{
                width: "150px",
                filter: "drop-shadow(0 8px 20px rgba(0,0,0,0.25))",
              }}
            />
          </div>

          {/* TITULO */}
          <h1
            className="fw-bold"
            style={{
              fontSize: "5rem",
              color: "#0f0f6f",
              textShadow: "0 4px 12px rgba(235,199,100,0.5)",
              fontFamily: "Vend Sans, sans-serif",
              userSelect: "none",
              WebkitUserSelect: "none",
              MozUserSelect: "none",
              msUserSelect: "none",
            }}
          >
            Rocky
          </h1>

          {/* BIENVENIDA */}
          <p
            className="mt-1 text-center mx-auto"
            style={{
              color: "#0f0f0f",
              fontSize: "1.1rem",
              lineHeight: "1.5",
              userSelect: "none",
              WebkitUserSelect: "none",
              MozUserSelect: "none",
              msUserSelect: "none",
            }}
          >
            Acabas de iniciar sesión,&nbsp;<strong className="text-capitalize">{arrayUsers?.name}</strong>. ¡Esperamos que disfrutes tu experiencia aquí!
          </p>

          {/* DESCRIPCIÓN */}
          <p
            className="mt-4 d-flex text-justify justify-content-center mx-auto"
            style={{
              color: "#0f0f0f",
              maxWidth: "650px",
              fontSize: "1.2rem",
              lineHeight: "1.8",
              userSelect: "none",
              WebkitUserSelect: "none",
              MozUserSelect: "none",
              msUserSelect: "none",
            }}
          >
            Este es un aplicativo diseñado para el registro de soportes, cuyo objetivo
            es mejorar el manejo de la información en el sector de servicios.
            Facilitamos la organización y gestión de datos, consolidando todo en un
            solo lugar para una experiencia más clara y profesional.
          </p>

        </div>
      </div>

    </>
  );
};
